import cn from 'classnames';
import styles from './FinanceStatusBadge.module.css';
import { Badge } from '@round/ui-kit';
import React from 'react';
import { financeStatusOptions } from '../helpers';

type Props = {
    financeStatus: string;
};

const FinanceStatusBadge = ({ financeStatus }: Props) => (
    <Badge className={cn(styles.badge, styles[financeStatus.toLowerCase()])}>
        {financeStatusOptions.find((o) => o.value === financeStatus)?.label}
    </Badge>
);

export default FinanceStatusBadge;
